<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="pt1" epub:type="part" role="doc-part">
<header>
<h1 class="PT" id="pt1"><span aria-label="5" id="pg_5" role="doc-pagebreak"><samp class="SANS_Baruta_Black_B_17">INTRODUCTION</samp></span></h1>
</header>
<p class="Intro"><samp class="SANS_Menco_Light_17">When I tell people that I work as an illustrator, it’s not always easy to describe my job or explain what I do. It has been—and still is—an exciting journey, and for me, one of the perks of being an illustrator is that it’s an ever-challenging and constantly new experience. Drawing is, of course, at the core of my work. I’ve always loved drawing. Like many, I started when I was still a child. I vividly remember drawing in my primary school books, filling them with sketches and impressions, and I feel like I’ve never stopped.</samp></p>
<p class="Intro"><samp class="SANS_Menco_Light_17">Of course, my practice has evolved since then. During my academic studies back in Italy, I fell in love with watercolor, which has become my favorite artistic technique by far, and I started to explore photography as well.</samp></p>
<p class="Intro"><samp class="SANS_Menco_Light_17">Photography eventually led me to fashion, and not long after, I decided to move to Paris, where I briefly worked in the womenswear department of a trend-forecasting agency. During that time, I felt like all of my interests could be combined in fashion illustration, and from that moment on I’ve worked hard to make this my full-time job. Over the years I’ve also trained as a teacher, led some classes in Italy, and, more recently, tutored a monthly fashion life-drawing class for over two years in London. It has been a very enriching experience, and I see this book as the natural following step.</samp></p>
<figure class="IMG-NOBOT"><img alt="" height="917" src="images/pg5.jpg" width="560"/>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?5c994b08